export default "/images/vendor/@coreui/icons/svg/flag/cif-bg.svg?24945d1561571fe582c2dd4d6be7d1e5";